import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { KycService } from '@app/core/kyc.service';

@Injectable()
export class ReferralCodeGuard implements CanActivate {
  constructor(private router: Router, private kycServie: KycService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.kycServie.browserRefresh) {
      const referralCode = window.localStorage.getItem('referralCode');
      if (referralCode) {
        this.router.navigate(['../home'], {
          queryParams: { referralCode: referralCode }
        });
      } else {
        this.router.navigateByUrl('/home');
      }
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/route-guard/referral-code-guard.ts